<template>
  <div class="chartOfAccount-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "chartOfAccountBase",
};
</script>
